import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	DishFullInfoContext,
	IDishFullInfoContext,
} from '../../../../../../../../../dishFullInfoState/dishFullInfoContext';
import style from './CategoriesField.module.scss';

const CategoriesField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return (
		<div className={style.container}>
			<Text translationNameSpace="form" translationKey="categoriesLabel" theme="neutralLight" size="xs" />
			<div className={style.categoriesList}>
				{dishForFullInfo?.categories.length
					? dishForFullInfo.categories.map((el) => {
							return (
								<div key={el.id} className={style.item}>
									<div className={style.dot} />
									<Text translationKey={el.name} size="s" withTooltip={true} />
								</div>
							);
					  })
					: '-'}
			</div>
		</div>
	);
};

export default CategoriesField;
